"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VeriLiteEventAction = /** @class */ (function () {
    function VeriLiteEventAction(text, color, callback, isDisabled) {
        if (isDisabled === void 0) { isDisabled = false; }
        this.text = text;
        this.color = color;
        this.isDisabled = isDisabled;
        this.callback = callback;
    }
    return VeriLiteEventAction;
}());
exports.VeriLiteEventAction = VeriLiteEventAction;
//# sourceMappingURL=EventAction.js.map